export const validateJsonValue = (value) => {
  const validation = {
    success: true,
    messages: [],
  };
  let allHaveTitle = true;
  value.map((current) => {
    if (!current.title) {
      allHaveTitle = false;
    } else {
      current.subSectionsList.map((sub) => {
        if (sub.hasOwnProperty("sub_heading_title")) {
          if (!sub.sub_heading_title) {
            allHaveTitle = false;
          }
        } else {
          if (!sub.title) {
            allHaveTitle = false;
          }
        }
      });
    }
  });
  if (!allHaveTitle) {
    validation.messages.push("All fields are mandatory.");
    validation.success = false;
  }
  return validation;
};
